import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import TvErrorBoundary from './components/TvErrorBoundary'
import { initSentry } from './lib/sentry'
// Readex Pro 600 for the wordmark (bundled, so it works on offline gym TVs).
import '@fontsource/readex-pro/600.css'
import './index.css'

// Before render so even boot-time crashes are captured. No-op without a DSN.
initSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Boundary OUTSIDE App: an unattended gym TV must never end up on a
        permanently black screen. See TvErrorBoundary for the auto-reload
        + crash-loop strategy. */}
    <TvErrorBoundary>
      <App />
    </TvErrorBoundary>
  </React.StrictMode>
)
